import type { Tool } from '@/types/editor';
import { TOOL_LABELS, TOOL_ICONS } from '@/types/editor';

interface EditorToolbarProps {
  activeTool: Tool;
  onToolChange: (tool: Tool) => void;
}

const TOOLS: { tool: Tool; shortcut: string }[] = [
  { tool: 'select', shortcut: 'V' },
  { tool: 'text', shortcut: 'T' },
  { tool: 'rectangle', shortcut: 'R' },
  { tool: 'ellipse', shortcut: 'E' },
  { tool: 'image', shortcut: 'I' },
];

export function EditorToolbar({ activeTool, onToolChange }: EditorToolbarProps) {
  return (
    <div className="editor-toolbar" role="toolbar" aria-label="Editor tools">
      {TOOLS.map(({ tool, shortcut }) => (
        <button
          key={tool}
          className={`editor-toolbar-button ${activeTool === tool ? 'active' : ''}`}
          onClick={() => onToolChange(tool)}
          aria-pressed={activeTool === tool}
          aria-label={`${TOOL_LABELS[tool]} tool (${shortcut})`}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d={TOOL_ICONS[tool]} />
          </svg>
          <span className="editor-toolbar-tooltip">
            {TOOL_LABELS[tool]} ({shortcut})
          </span>
        </button>
      ))}

      <div className="editor-toolbar-divider" />

      {/* Asset library button for future enhancement */}
      <button
        className="editor-toolbar-button"
        aria-label="Asset library"
        title="Asset library (coming soon)"
        disabled
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="14" y="14" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
        </svg>
        <span className="editor-toolbar-tooltip">Assets (coming soon)</span>
      </button>
    </div>
  );
}
